<template>
  <div v-if="isAuth" class="profile-link">
    <a
      :href="$getSubdomainLink('portal', '/my-profile/personal-info')"
      class=""
      :class="{
        active: $route.path.includes('/my-profile/personal-info'),
      }"
    >
      My profile
    </a>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores";
export default {
  name: "ProfileLink",
  data() {
    return {
      authStore: useAuthStore(),
    };
  },
  computed: {
    isAuth() {
      return this.authStore.isAuth;
    },
  },
};
</script>
